class inputApproveCtrl {
    constructor($scope, httpRequest) {
        httpRequest.post_queryReportUrl(localStorage.defaultKey).then((res) => {
            if (res.data.success) {
                $scope.url = res.data.value.url
            }
        })
    }
}

inputApproveCtrl.$inject = ['$scope', 'httpRequest']
export default inputApproveCtrl



// WEBPACK FOOTER //
// ./src/app/statistics/chartAnalysis/inputApprove/inputApproveCtrl.js